<script>
import {getTimesheetStatusName} from "@/utility/helpers";

const dayjs = require("dayjs");

const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
    monthData: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      dayjs,
      firstMatchingDay: null,
      lastMatchingDay: null,
    }
  },
  methods: {
    getStatusName(status) {
      return this.$t(getTimesheetStatusName(status));
    },
    close() {
      this.$emit('close');
    },
    deleteOnlySelected() {
      this.$emit('delete-selected');
    },
    deleteAllOccurrences() {
      this.$emit('delete-all', {
        firstMatchingDay: this.firstMatchingDay,
        lastMatchingDay: this.lastMatchingDay,
        matchingDays: this.monthData.filter((day) => {
          const dayDate = dayjs(day.day);
          const firstDay = dayjs(this.firstMatchingDay);
          const lastDay = dayjs(this.lastMatchingDay);
          return (
              day.status_decoded === this.status.status_decoded &&
              dayDate.isSameOrAfter(firstDay) &&
              dayDate.isSameOrBefore(lastDay)
          );
        })
      });
    },
    findLastMatchingDay() {
      const currentDayIndex = this.monthData.findIndex(
          (day) => day.day === this.status.day
      );

      let firstMatchingDay = this.status.day;
      for (let i = currentDayIndex - 1; i >= 0; i--) {
        if (this.monthData[i].status_decoded !== this.status.status_decoded) {
          break;
        }
        firstMatchingDay = this.monthData[i].day;
      }

      let lastMatchingDay = this.status.day;
      for (let i = currentDayIndex + 1; i < this.monthData.length; i++) {
        if (this.monthData[i].status_decoded !== this.status.status_decoded) {
          break;
        }
        lastMatchingDay = this.monthData[i].day;
      }

      this.firstMatchingDay = firstMatchingDay;
      this.lastMatchingDay = lastMatchingDay;
    },
  },
  watch: {
    isVisible: {
      handler(newVal) {
        if(newVal) {
          this.findLastMatchingDay();
        }
      },
      immediate: true,
    }
  }
};
</script>

<template>
  <v-dialog v-model="isVisible" @input="close" max-width="665px">
    <v-card class="d-flex flex-column align-center py-6 px-1 relative overflow-hidden" style="border-radius: 15px !important;">
      <v-btn icon width="22" height="22" class="modal-close" @click="close">
        <v-icon size="20px" color="#9BA1AE">mdi-close</v-icon>
      </v-btn>
      <v-card-title class="modal-title word-break">
        {{ $t('Employee.date_format', { date: dayjs(status.day).format('D MMMM').toLowerCase(), status: getStatusName(status.status_decoded), text: $t('Employee.delete_status.delete') }) }}
      </v-card-title>
      <v-card-text class="modal-text">
        {{ $t('Employee.delete_status.delete_confirmation', { status: getStatusName(status.status_decoded) }) }}
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="firstMatchingDay !== status.day || lastMatchingDay !== status.day" class="modal-btn delete-one" text @click="deleteAllOccurrences">
          {{ $t('Employee.delete_status.delete_days', { starting: dayjs(firstMatchingDay).format('D'), finished: dayjs(lastMatchingDay).format('D') }) }}
        </v-btn>
        <v-btn class="modal-btn delete-all" text @click="deleteOnlySelected">
          {{ $t('Employee.delete_status.delete_day', { selected: dayjs(status.day).format('D') }) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.word-break {
  word-break: normal;
}

.modal-close {
  position: absolute;
  top: 5%;
  right: 2%;
}

.modal-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  text-align: center;
}

.modal-text {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #000000 !important;
}

.modal-btn {
  padding: 12px 12px !important;
  color: #FFFFFF;
  text-transform: none;
  font-size: 16px;
  &.delete-one {
    background-color: #9CA3AF;
  }
  &.delete-all {
    background-color: #116ACC;
  }
}
</style>
